import React from 'react'
import { MENU } from '@/config/menu.config'
import { cn } from '@/lib/utils'
import { ArrowRight } from 'lucide-react'

interface CompanyMenuProps {
  onMouseEnter: () => void
  onMouseLeave: () => void
}

export function CompanyMenu({ onMouseEnter, onMouseLeave }: CompanyMenuProps) {
  const companyItem = MENU.find(item => item.label === 'Company')
  
  if (!companyItem?.children) return null

  const links = companyItem.children.filter(child => 'label' in child && 'href' in child && !('group' in child)) as Array<{ label: string; href: string }>

  return (
    <div
      className="fixed inset-x-0 top-20 z-50 flex justify-center animate-in fade-in slide-in-from-top-2 duration-200"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="w-[400px] max-w-[90vw]">
      <div 
        className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl"
      >
        <div className="p-4">
          <h3 className="text-sm font-semibold text-primary uppercase tracking-wide mb-4 px-2">
            Company
          </h3>
          
          <ul className="space-y-1">
            {links.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  className={cn(
                    "flex items-center justify-between p-3 rounded-lg transition-all duration-200",
                    "hover:bg-muted/50 hover:text-primary hover:translate-x-1 group"
                  )}
                >
                  <span className="text-sm font-medium">{link.label}</span>
                  <ArrowRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity transform group-hover:translate-x-1" />
                </a>
              </li>
            ))}
          </ul>
          
          {/* Bottom highlight */}
          <div 
            className="mt-4 pt-4 border-t border-border"
          >
            <div className="px-2">
              <p className="text-xs text-muted-foreground">
                Part of RASTEC Group since 1995
              </p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}
